import React from "react";
import styled from "styled-components";
import useWindowDimensions from "../constatns/size";

import "../styles/home.css";

function BgTitle({ bgTitle, grTitleStyle }) {
    const { width } = useWindowDimensions();
  return <GrTitle style={grTitleStyle} width={width}>{ bgTitle }</GrTitle>
}

export function Title({ title, mainTitleStyle }) {
  const { width, height } = useWindowDimensions();
  
return <MainTitle style={mainTitleStyle} width={width} height={height}>{ title }</MainTitle>
}

const GrTitle = styled.p`
    background: -webkit-linear-gradient( 90deg, #1F244F, #3C4380);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: ${({width})=> width * 0.08}px;
    opacity: 0.4;
    margin: 0px;
    padding: 0px;
    text-align: center;
    margin-top: 20px;
    font-weight: bold;

    @media (max-width: 768px) {
      font-size: ${({width})=> width * 0.1}px;

    }
`;

const MainTitle = styled.h1`
    text-align: center;
    color: white;
    position: absolute;
    font-weight: 500;
    margin-top: -${({height})=> height * 0.11}px;
    left: 0px;
    right: 0px;

    @media (max-width: 768px) {
      margin-top: -${({height})=> height * 0.04}px;
      font-size: ${({width})=> width * 0.06}px;

    }
`

export default BgTitle;
